export const EVENT_INFO = {
  id: "evt_7892",
  name: "Project Nebula Launch Gala",
  date: "2084.11.15",
  location: "Sector 4 Sky Lounge",
  status: "LIVE",
  countdown: "00:04:23:09",
  overallEnergy: 87,
  budgetUsed: 68,
};

export const TIMELINE_DATA = [
  { id: 1, time: "16:00", title: "Vendor Load-in", owner: "Logistics Team", status: "completed", type: "vendor" },
  { id: 2, time: "18:00", title: "A/V System Check", owner: "Tech Crew", status: "completed", type: "tech" },
  { id: 3, time: "19:00", title: "VIP Arrivals & Champagne", owner: "Host Commitee", status: "active", type: "guest" },
  { id: 4, time: "20:30", title: "Keynote Hologram Presentation", owner: "CEO", status: "pending", type: "main" },
  { id: 5, time: "21:15", title: "Dinner Service Initiated", owner: "Catering Head", status: "pending", type: "food" },
  { id: 6, time: "23:00", title: "Entertainment Phase", owner: "DJ Zenith", status: "pending", type: "main" },
];

export const GUEST_DATA = [
  { id: "g1", name: "Elara Vance", status: "Arrived", table: "Alpha-1", energy: 92, note: "Vegan", tier: "VIP" },
  { id: "g2", name: "Kaelen Voss", status: "Expected", table: "Alpha-2", energy: 45, note: "VIP", tier: "VVIP" },
  { id: "g3", name: "Dr. Aris Thorne", status: "Arrived", table: "Beta-1", energy: 88, note: "None", tier: "General" },
  { id: "g4", name: "Mira Solis", status: "Arrived", table: "Alpha-1", energy: 95, note: "Allergic: Nuts", tier: "Press" },
  { id: "g5", name: "Jaxon Rex", status: "No Show", table: "Gamma-3", energy: 0, note: "None", tier: "General" },
  { id: "g6", name: "Sera Lumina", status: "Expected", table: "Beta-2", energy: 60, note: "Press", tier: "Press" },
  { id: "g7", name: "Orion Black", status: "Arrived", table: "Gamma-1", energy: 78, note: "None", tier: "VIP" },
  { id: "g8", name: "Lyra Star", status: "Expected", table: "Beta-1", energy: 50, note: "Halal", tier: "General" },
];

export const VENDOR_DATA = [
  { id: "v1", name: "Starlight Catering", type: "Food & Bev", status: "Operational", rating: 4.8, contact: "Comm-Link A" },
  { id: "v2", name: "Holo-Visuals Inc.", type: "A/V Tech", status: "Standby", rating: 4.9, contact: "Comm-Link B" },
  { id: "v3", name: "Aero-Decor", type: "Atmosphere", status: "Completed", rating: 4.5, contact: "Comm-Link C" },
  { id: "v4", name: "Security Nexus", type: "Protection", status: "Operational", rating: 5.0, contact: "Secure Channel" },
];

export const BUDGET_DATA = {
  total: 150000,
  spent: 102500,
  breakdown: [
    { name: 'Venue & Atmosphere', value: 45000 },
    { name: 'Food & Beverage', value: 35000 },
    { name: 'A/V & Tech', value: 15000 },
    { name: 'Talent & Entertainment', value: 5000 },
    { name: 'Contingency', value: 2500 }
  ]
};

export const DEMO_WORKFLOW = [
  { id: 1, title: "Studio Initialization", description: "Define parameters, dates, and cosmic theme constraints.", icon: "FiZap", action: "Configure Protocol", status: "completed" },
  { id: 2, title: "Guest Matrix Sync", description: "Import guest data and assign dynamic table coordinates.", icon: "FiUsers", action: "Sync Registry", status: "active" },
  { id: 3, title: "Vendor Node Linking", description: "Establish secure comm-links with verified service providers.", icon: "FiLink", action: "Connect Nodes", status: "pending" },
  { id: 4, title: "Resource Allocation", description: "Distribute credits and track real-time expenditure.", icon: "FiPieChart", action: "Finalize Budget", status: "pending" },
  { id: 5, title: "Command Activation", description: "Launch the day-of command screen for live telemetry.", icon: "FiPlay", action: "Go Live", status: "pending" },
  { id: 6, title: "Energy Analytics", description: "Analyze guest impact and vendor performance metrics.", icon: "FiActivity", action: "Generate Report", status: "pending" }
];

export const FAQ_DATA = [
  { q: "How does the 'Guest Energy' meter work?", a: "We simulate guest engagement using check-in velocity, table interaction density, and feedback signals to provide a live atmosphere score." },
  { q: "Can I manage multiple events at once?", a: "Yes, the EventNova Studio Pro license allows for concurrent 'Command Centers' with shared vendor resources." },
  { q: "Is the simulation data real?", a: "This demo uses encrypted dummy records to showcase system behavior without exposing PII or real financial data." },
  { q: "How do I integrate my own vendors?", a: "The 'Vendor Board' supports custom node-linking via our secure API protocol (manual entry available in this demo)." },
  { q: "What happens if a vendor goes offline?", a: "Our system triggers a 'Warning' state (see Simulated States) and suggests immediate backup nodes from your linked network." }
];